var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup115(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 364,
    viewBox: "0 0 502 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 502,
    height: 364,
    rx: 10,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294 189.152H258.167V224.986C258.167 226.886 257.412 228.709 256.068 230.053C254.724 231.397 252.901 232.152 251 232.152C249.099 232.152 247.277 231.397 245.933 230.053C244.589 228.709 243.833 226.886 243.833 224.986V189.152H208C206.099 189.152 204.277 188.397 202.933 187.053C201.589 185.709 200.833 183.886 200.833 181.986C200.833 180.085 201.589 178.262 202.933 176.918C204.277 175.574 206.099 174.819 208 174.819H243.833V138.986C243.833 137.085 244.589 135.262 245.933 133.918C247.277 132.574 249.099 131.819 251 131.819C252.901 131.819 254.724 132.574 256.068 133.918C257.412 135.262 258.167 137.085 258.167 138.986V174.819H294C295.901 174.819 297.724 175.574 299.068 176.918C300.412 178.262 301.167 180.085 301.167 181.986C301.167 183.886 300.412 185.709 299.068 187.053C297.724 188.397 295.901 189.152 294 189.152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup115);
export default __webpack_public_path__ + "static/media/Group 115.eae5f2cdbaa405a04176abe290e39a63.svg";
export { ForwardRef as ReactComponent };